/**
 * RouteLoader Component
 *
 * Provides a consistent loading state for lazy-loaded routes.
 * Migrated to Polaris web components (per Plan T20).
 *
 * Usage: Fallback component for React.Suspense boundaries
 */
export default function RouteLoader() {
  return (
    <s-stack
      direction="block"
      alignItems="center"
      justifyContent="center"
      gap="base"
      padding="large"
      style={{ minHeight: "60vh" }}
    >
      <s-spinner accessibilityLabel="Loading route" size="large-100" />
      <s-text color="subdued">Loading…</s-text>
    </s-stack>
  );
}
